import { dispatcher } from "../../../helpers/projectHelper";
import { curatorActions } from "../../../redux/slicers/admin/curatorSlicer";
import { deleteCurrentProjectBackup, saveCurrentProgress } from "./curatorAutosave";


export const DIRTY_TYPE = {
  MATERIAL_PROPERTIES: 'MATERIAL_PROPERTIES', 
}

const state = {
  saved: true,
  cameraSaved: true,
};

export const setCuratorNotSaved = ({ saveTempData = true } = {}) => {
  state.saved = false;
  dispatcher(curatorActions.setSaved(false))

  if (saveTempData) {
    saveCurrentProgress();
  }
};

export const scns = setCuratorNotSaved;

export const setCuratorSaved = () => {
  state.saved = true;
  state.cameraSaved = true;
  dispatcher(curatorActions.setSaved(true))

  deleteCurrentProjectBackup();
};



export const isCuratorSaved = () => state.saved

export const setCameraSaved = () => {
  state.cameraSaved = true;
}

export const setCameraNotSaved = () => {
  state.cameraSaved = false;
}

export const isCameraSaved = () => state.cameraSaved

window.isCuratorSaved = isCuratorSaved;
window.setCuratorNotSaved = setCuratorNotSaved;
window.setCuratorSaved = setCuratorSaved;